import { ROUTES_CREATE_EVENT } from '@/constants/routes';
export default {
    path: '/create-event/:id?',
    name: ROUTES_CREATE_EVENT,
    component: () => import(/*webpackChunkName: 'create-event'*/ '@/views/CreateEvent.vue')
};
